import { GTM_STATUS_ENUM_TO_LABEL_MAP } from '../../CreateBooking/constants/DetailedBookingConstants';

/**
 * A selectable value for a bulk-editable column. `label` is an i18n key resolved at render time.
 */
export interface BulkEditableValueOption {
  value: string;
  label: string;
}

/**
 * A column that can be bulk-edited from the queue sheet. To make another column bulk-editable, add
 * an entry here (and, if it is a new field, matching backend support in the batch endpoint); the
 * bulk-edit bar picks these up automatically.
 */
export interface BulkEditableColumn {
  /** Logical column key sent to the dispatcher (e.g. 'gtmStatus'). */
  key: string;
  /** i18n key for the column's display name, resolved with t() at render time. */
  label: string;
  /** Allowed values for this column. */
  valueOptions: ReadonlyArray<BulkEditableValueOption>;
}

export const BULK_EDITABLE_COLUMNS: ReadonlyArray<BulkEditableColumn> = [
  {
    key: 'gtmStatus',
    label: 'bulk-edit-column-gtm-status',
    valueOptions: GTM_STATUS_ENUM_TO_LABEL_MAP.map((option) => ({
      value: option.value,
      label: option.label,
    })),
  },
];
